import { Model } from '@contember/schema';
import { isColumn, isRelation } from '@contember/schema-utils';
import { sentenceCase } from 'change-case';
import { produce } from 'immer';
import { CREATED_AT_FIELD } from '../../common';
import { getDefaultColumnType, getDefaultFieldType, isDataGridScope, isDetailScope, isNavigateEvent, isPluginScope, removeSurroundingQuotes, } from '../helpers';
import { addColumn, removeColumn } from './columnManagement';
import { addComment, removeComment, updateComment } from './commentManagement';
import { addReadout, addReadoutField, removeReadout, removeReadoutField, removeReadoutFromScope } from './readoutManagement';
import { AppStructureBuilderError } from './error';
import { addCreateForm, addForm, addFormField, removeCreateForm, removeElement, removeForm, removeFormFromScope, sortElements, } from './formManagement';
import { addPlugin, removePlugin } from './pluginManagement';
import { addPreview, addPreviewField, removePreview, removePreviewField, removePreviewFromForm, } from './previewManagement';
import { addFilterScope, addScope, allowScope, denyScope, removeFilterScope, removeScope } from './scopeManagement';
import { addView, removeView, renameView, replaceEventTarget, replaceNavigationTarget } from './viewManagement';
export class StructureBuilder {
    constructor(application, schema, schemaExtensions) {
        Object.defineProperty(this, "application", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: application
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: schema
        });
        Object.defineProperty(this, "schemaExtensions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: schemaExtensions
        });
        Object.defineProperty(this, "addView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addView
        });
        Object.defineProperty(this, "removeView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeView
        });
        Object.defineProperty(this, "renameView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: renameView
        });
        Object.defineProperty(this, "replaceNavigationTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: replaceNavigationTarget
        });
        Object.defineProperty(this, "replaceEventTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: replaceEventTarget
        });
        Object.defineProperty(this, "addScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addScope
        });
        Object.defineProperty(this, "removeScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeScope
        });
        Object.defineProperty(this, "addFilterScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addFilterScope
        });
        Object.defineProperty(this, "removeFilterScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeFilterScope
        });
        Object.defineProperty(this, "allowScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: allowScope
        });
        Object.defineProperty(this, "denyScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: denyScope
        });
        Object.defineProperty(this, "addForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addForm
        });
        Object.defineProperty(this, "removeForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeForm
        });
        Object.defineProperty(this, "removeFormFromScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeFormFromScope
        });
        Object.defineProperty(this, "addCreateForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addCreateForm
        });
        Object.defineProperty(this, "removeCreateForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeCreateForm
        });
        Object.defineProperty(this, "addFormField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addFormField
        });
        Object.defineProperty(this, "removeElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeElement
        });
        Object.defineProperty(this, "sortElements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sortElements
        });
        Object.defineProperty(this, "addReadout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addReadout
        });
        Object.defineProperty(this, "removeReadout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeReadout
        });
        Object.defineProperty(this, "removeReadoutFromScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeReadoutFromScope
        });
        Object.defineProperty(this, "addReadoutField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addReadoutField
        });
        Object.defineProperty(this, "removeReadoutField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeReadoutField
        });
        Object.defineProperty(this, "addColumn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addColumn
        });
        Object.defineProperty(this, "removeColumn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeColumn
        });
        Object.defineProperty(this, "addPreview", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addPreview
        });
        Object.defineProperty(this, "removePreview", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removePreview
        });
        Object.defineProperty(this, "removePreviewFromForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removePreviewFromForm
        });
        Object.defineProperty(this, "addPreviewField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addPreviewField
        });
        Object.defineProperty(this, "removePreviewField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removePreviewField
        });
        Object.defineProperty(this, "addComment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addComment
        });
        Object.defineProperty(this, "removeComment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removeComment
        });
        Object.defineProperty(this, "updateComment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: updateComment
        });
        Object.defineProperty(this, "addPlugin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addPlugin
        });
        Object.defineProperty(this, "removePlugin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: removePlugin
        });
    }
    addNavigationItem({ label, viewName, icon }) {
        const viewNameTemp = viewName === 'undefined' ? undefined : viewName;
        this.updateAppStructure(draftBuilder => {
            if (viewNameTemp && !this.getView(viewNameTemp)) {
                throw new AppStructureBuilderError(`View ${viewNameTemp} not found for navigation item ${label}`);
            }
            const labels = label.split('->').map(it => removeSurroundingQuotes(it));
            let currentLevel = draftBuilder.application.navigation;
            labels.forEach((labelPart, index) => {
                let item = currentLevel?.find(it => it.label === labelPart);
                if (!item) {
                    item = { label: labelPart };
                    if (index === labels.length - 1) {
                        item.viewName = viewNameTemp;
                        if (icon) {
                            item.icon = icon;
                        }
                    }
                    currentLevel?.push(item);
                }
                else {
                    if (index === labels.length - 1) {
                        item.viewName = viewNameTemp;
                        if (icon) {
                            item.icon = icon;
                        }
                    }
                }
                if (index < labels.length - 1) {
                    item = {
                        ...item,
                        children: item.children || [],
                    };
                    currentLevel = item.children;
                }
            });
        });
        return this;
    }
    removeNavigationItem({ label }) {
        this.updateAppStructure(draftBuilder => {
            const labels = label.split('->').map(it => removeSurroundingQuotes(it));
            let currentLevel = draftBuilder.application.navigation;
            labels.forEach((labelPart, index) => {
                const item = currentLevel.find(it => it.label === labelPart);
                if (!item) {
                    throw new AppStructureBuilderError(`Navigation item ${labelPart} not found`);
                }
                if (index === labels.length - 1) {
                    const index = currentLevel.indexOf(item);
                    currentLevel.splice(index, 1);
                }
                else {
                    currentLevel = item.children || [];
                }
            });
        });
        return this;
    }
    sortNavigationItems({ labels, label }) {
        this.updateAppStructure(draftBuilder => {
            const navigation = draftBuilder.application.navigation;
            const changeNavigationOrder = (items) => {
                const sortedItems = items?.sort((a, b) => {
                    if (labels.includes(a.label) && labels.includes(b.label)) {
                        return labels.indexOf(a.label) - labels.indexOf(b.label);
                    }
                    if (labels.includes(a.label)) {
                        return -1;
                    }
                    if (labels.includes(b.label)) {
                        return 1;
                    }
                    return 0;
                });
                for (const item of sortedItems ?? []) {
                    if (item.children) {
                        changeNavigationOrder(item.children);
                    }
                }
            };
            if (label) {
                const item = navigation.find(it => {
                    return it.label === label;
                });
                if (!item) {
                    throw new AppStructureBuilderError(`Navigation item ${label} not found`);
                }
                let parent = navigation.find(it => it.children?.includes(item));
                if (!parent) {
                    changeNavigationOrder(navigation);
                }
                else {
                    parent = { ...parent, children: parent.children || [] };
                    changeNavigationOrder(parent.children);
                }
            }
            else {
                changeNavigationOrder(navigation);
            }
        });
        return this;
    }
    addEvent({ eventName, eventLabel, sourceScopeName, sourceViewName, eventType, eventPosition, targetViewName, }) {
        this.updateAppStructure(draftBuilder => {
            if (!eventType) {
                throw new AppStructureBuilderError(`Event type is not defined for event ${eventName}`);
            }
            const view = draftBuilder.getView(sourceViewName);
            if (!view) {
                throw new AppStructureBuilderError(`View ${sourceViewName} not found. You cannot create an event in a non-existing view.`);
            }
            if (targetViewName && !draftBuilder.getView(targetViewName)) {
                throw new AppStructureBuilderError(`Target view ${targetViewName} not found. You cannot create a ${eventType} event to a non-existing view.`);
            }
            if (eventType === 'navigate' || eventType === 'redirectOnPersist') {
                if (!targetViewName) {
                    throw new AppStructureBuilderError(`Target view is not defined for ${eventType} event ${eventName}`);
                }
                const targetView = draftBuilder.getView(targetViewName);
                if (!targetView) {
                    // throw new AppStructureBuilderError(
                    // 	`Target view ${targetViewName} not found. You cannot create a ${eventType} event to a non-existing view. Available views: ${Object.keys(draftBuilder.application.views).join(', ')}`
                    // );
                }
            }
            const event = this.newEvent(eventName, eventLabel, eventType, eventPosition, targetViewName);
            if (sourceScopeName) {
                const scope = view.scopes[sourceScopeName];
                if (!scope) {
                    throw new AppStructureBuilderError(`Scope ${sourceScopeName} not found in view ${sourceViewName}`);
                }
                scope.events = { ...(scope.events || {}), [eventName]: event };
            }
            else {
                view.events = { ...(view.events || {}), [eventName]: event };
            }
        });
        return this;
    }
    removeEvent({ eventName, sourceViewName, sourceScopeName, eventPosition, }) {
        this.updateAppStructure(draftBuilder => {
            const sourceView = draftBuilder.getView(sourceViewName);
            const removeEvent = (events) => {
                if (!events)
                    return;
                if (events[eventName]) {
                    delete events[eventName];
                }
            };
            if (!sourceView.name) {
                throw new AppStructureBuilderError(`View ${sourceViewName} not found. You cannot remove an event from a non-existing view.`);
            }
            if (sourceScopeName) {
                const scope = sourceView.scopes[sourceScopeName];
                if (!scope) {
                    throw new AppStructureBuilderError(`Scope ${sourceScopeName} not found in view ${sourceViewName}. You cannot remove an event from a non-existing scope.`);
                }
                if (eventPosition) {
                    const event = scope.events?.[eventName];
                    if (event && event.position === eventPosition) {
                        removeEvent(scope.events);
                    }
                }
                else {
                    removeEvent(scope.events);
                }
                return;
            }
            if (!sourceView?.events) {
                throw new AppStructureBuilderError(`${sourceViewName} does not have any events. You cannot remove an event from a view without events.`);
            }
            if (sourceView?.events) {
                if (eventPosition) {
                    const event = sourceView.events[eventName];
                    if (!event) {
                        throw new AppStructureBuilderError(`Event ${eventName} not found in view ${sourceViewName}. You cannot remove a non-existing event.`);
                    }
                    if (event && event.position === eventPosition) {
                        removeEvent(sourceView.events);
                    }
                }
                else {
                    removeEvent(sourceView.events);
                }
            }
        });
        return this;
    }
    get newEvent() {
        return this.createEvent;
    }
    get newReadout() {
        return this.createReadout;
    }
    get newPreview() {
        return this.createPreview;
    }
    get newForm() {
        return this.createForm;
    }
    get isEventInView() {
        return this.eventExistsInView;
    }
    get isEventInScope() {
        return this.eventExistsInScope;
    }
    get newScope() {
        return this.createScope;
    }
    get newDefaultField() {
        return this.createDefaultField;
    }
    get newDefaultColumn() {
        return this.createDefaultColumn;
    }
    get newDefaultDetailField() {
        return this.createDefaultDetailField;
    }
    get newDefaultPreviewField() {
        return this.createDefaultPreviewField;
    }
    get newElementField() {
        return this.createElementField;
    }
    get newElementColumn() {
        return this.createElementColumn;
    }
    formExists(formName) {
        return !!this.application.forms[formName];
    }
    isPluginRelation({ fieldName, entityName }) {
        return Object.values(this.schemaExtensions.plugins).some(plugin => plugin.connectedTo[entityName]?.fields?.includes(fieldName));
    }
    getScopesByReadoutName(readoutName) {
        const scopes = [];
        const views = Object.values(this.application.views);
        for (const view of views) {
            for (const scope of Object.values(view.scopes)) {
                if (!isDetailScope(scope))
                    continue;
                if (scope.readouts?.includes(readoutName)) {
                    scopes.push(scope);
                }
            }
        }
        return scopes;
    }
    getReadout(readoutName) {
        return this.application.readouts[readoutName];
    }
    getEventsByTargetViewName(targetViewName) {
        const events = [];
        const views = Object.values(this.application.views);
        for (const view of views) {
            if (!view.events)
                continue;
            for (const event of Object.values(view.events)) {
                if (isNavigateEvent(event) && event.targetViewName === targetViewName) {
                    events.push(event);
                }
            }
        }
        return events;
    }
    getPreview(previewName) {
        return this.application.previews[previewName];
    }
    createReadout({ readoutName, entityName }) {
        return { name: readoutName, entityName, fields: {} };
    }
    createPreview({ previewName, entityName }) {
        return { name: previewName, entityName, fields: {} };
    }
    createForm({ formName, entityName }) {
        return this.getForm(formName) ?? { name: formName, entityName, fields: {} };
    }
    eventExistsInView(event, view) {
        if (view?.events?.[event.name]) {
            const existingEvent = view.events[event.name];
            if (isNavigateEvent(event) && isNavigateEvent(existingEvent)) {
                return existingEvent.position === event.position && existingEvent.type === event.type && existingEvent.targetViewName === event.targetViewName;
            }
            return existingEvent.position === event.position && existingEvent.type === event.type;
        }
        return false;
    }
    eventExistsInScope(event, scope) {
        if (scope.events?.[event.name]) {
            const existingEvent = scope.events[event.name];
            if (isNavigateEvent(event) && isNavigateEvent(existingEvent)) {
                return existingEvent.position === event.position && existingEvent.type === event.type && existingEvent.targetViewName === event.targetViewName;
            }
            return existingEvent.position === event.position && existingEvent.type === event.type;
        }
    }
    getFormEntityName(formName) {
        const form = this.application.forms[formName];
        if (!form) {
            throw new AppStructureBuilderError(`Form ${formName} not found`);
        }
        if (form.entityName) {
            return form.entityName;
        }
        const scopes = Object.values(this.application.views).flatMap(view => Object.values(view.scopes));
        const scope = scopes.find(scope => {
            if (isPluginScope(scope) || isDataGridScope(scope) || isDetailScope(scope)) {
                return false;
            }
            return scope.forms?.includes(formName);
        });
        return scope?.entityName;
    }
    createEvent(eventName, eventLabel, eventType, eventPosition, targetViewName) {
        const optionalTargetViewParams = (eventType === 'navigate' || eventType === 'redirectOnPersist') && this.hasEntityScope(targetViewName)
            ? { targetViewParams: '(id: $entity.id)' }
            : {};
        const optionalTargetViewName = eventType === 'navigate' ? { targetViewName } : {};
        if (!eventType) {
            throw new AppStructureBuilderError(`Event type is not defined for event ${eventName}`);
        }
        if (eventType === 'redirectOnPersist') {
            return {
                name: eventName,
                type: eventType,
                targetViewName,
                ...optionalTargetViewParams,
            };
        }
        if (!eventPosition) {
            throw new AppStructureBuilderError(`Event position is not defined for event ${eventName}`);
        }
        return {
            name: eventName,
            label: eventLabel ?? sentenceCase(eventName),
            type: eventType,
            position: eventPosition,
            ...optionalTargetViewName,
            ...optionalTargetViewParams,
        };
    }
    hasEntityScope(viewName) {
        if (!viewName)
            return false;
        const targetView = this.getView(viewName);
        if (!targetView)
            return false;
        return Object.values(targetView.scopes).some(scope => scope.type === 'edit' || scope.type === 'detail');
    }
    getForm(formName) {
        return this.application.forms[formName];
    }
    getEntityField(entityName, fieldName) {
        let entity = this.schema.model.entities[entityName];
        if (!entity) {
            throw new AppStructureBuilderError(`Entity ${entityName} not found`);
        }
        if (fieldName.includes('.')) {
            const relationFields = fieldName.split('.');
            for (const [index, relationField] of relationFields.entries()) {
                const field = entity.fields[relationField];
                if (!field) {
                    throw new AppStructureBuilderError(`Field ${relationField} not found in entity ${entityName}`);
                }
                if (index !== relationFields.length - 1) {
                    if (isRelation(field)) {
                        entity = this.schema.model.entities[field.target];
                        if (!entity) {
                            throw new AppStructureBuilderError(`Related entity for ${field.target} not found`);
                        }
                    }
                    else {
                        throw new AppStructureBuilderError(`${relationField} in ${entityName} is not a relation`);
                    }
                }
                else {
                    return field;
                }
            }
        }
        const field = entity.fields[fieldName];
        if (!field) {
            throw new AppStructureBuilderError(`Field ${fieldName} not found in entity ${entityName}`);
        }
        return field;
    }
    createScope({ scopeName, scopeType, entityName, filterQuery, }) {
        return {
            name: scopeName,
            type: scopeType,
            entityName,
            filter: filterQuery,
        };
    }
    createDefaultField({ fieldName, numberOfFields, modelField }) {
        return {
            order: numberOfFields,
            label: sentenceCase(fieldName),
            field: fieldName,
            name: fieldName,
            modelField: { ...modelField },
        };
    }
    createDefaultColumn({ columnName, numberOfColumns, modelField, }) {
        return {
            order: numberOfColumns,
            header: sentenceCase(columnName),
            field: columnName,
            name: columnName,
            modelField: { ...modelField },
        };
    }
    createDefaultDetailField({ fieldName, numberOfFields, modelField, }) {
        return {
            order: numberOfFields,
            label: sentenceCase(fieldName),
            field: fieldName,
            name: fieldName,
            modelField: { ...modelField },
        };
    }
    createDefaultPreviewField({ fieldName, numberOfFields, modelField, }) {
        return {
            order: numberOfFields,
            label: sentenceCase(fieldName),
            field: fieldName,
            name: fieldName,
            modelField: { ...modelField },
        };
    }
    getFieldType({ fieldType, modelField }) {
        return fieldType || this.getDefaultFieldType(modelField);
    }
    getColumnType({ columnType, modelField }) {
        return columnType || this.getDefaultColumnType(modelField);
    }
    getDefaultFieldType(modelField) {
        return getDefaultFieldType(modelField);
    }
    getDefaultColumnType(modelField) {
        return getDefaultColumnType(modelField);
    }
    getEnumOptions(modelField) {
        if (modelField.type === 'Enum') {
            return this.schema.model.enums[modelField.columnType].map(it => ({ value: it, label: sentenceCase(it) }));
        }
        throw new AppStructureBuilderError(`Field ${modelField.name} is not an enum`);
    }
    getView(viewName) {
        return this.application.views[viewName];
    }
    getScopeByView({ scopeName, viewName, throwOnError = true }) {
        const view = this.getView(viewName);
        const scope = view?.scopes[scopeName];
        if (!scope) {
            if (throwOnError) {
                throw new AppStructureBuilderError(`Scope ${scopeName} not found`);
            }
            return { scope: null, view };
        }
        return { scope, view };
    }
    getScopesByName(scopeName) {
        return Object.values(this.application.views)
            .map(it => it.scopes[scopeName])
            .filter(it => it);
    }
    getViewsByScopeName(scopeName) {
        const views = Object.values(this.application.views).filter(it => Object.values(it.scopes).some(scope => scope.name === scopeName));
        if (!views.length) {
            throw new AppStructureBuilderError(`View for scope ${scopeName} not found`);
        }
        return views;
    }
    createElementField({ fieldName, fieldType, modelField, plugin, numberOfFields = 0, pluginParams, }) {
        const defaultField = this.createDefaultField({ fieldName, numberOfFields, modelField });
        const type = this.getStructureFieldType(fieldType);
        switch (type) {
            case 'repeater':
                return {
                    ...defaultField,
                    orderBy: CREATED_AT_FIELD,
                    type,
                };
            case 'radio':
                if (isColumn(modelField)) {
                    return {
                        ...defaultField,
                        field: modelField.name,
                        type,
                        options: this.getEnumOptions(modelField),
                        modelField,
                    };
                }
                break;
            case 'select':
                if (isRelation(modelField)) {
                    return {
                        ...defaultField,
                        optionField: undefined,
                        type,
                    };
                }
                else {
                    return {
                        ...defaultField,
                        field: modelField.columnType,
                        type,
                        options: this.getEnumOptions(modelField),
                        modelField,
                    };
                }
            case 'multiselect':
                return {
                    ...defaultField,
                    optionField: undefined,
                    type,
                };
            case 'plugin': {
                let pluginName = plugin?.name;
                // TODO: check only current entity
                if (!pluginName) {
                    for (const plugin of Object.values(this.schemaExtensions.plugins)) {
                        for (const connectedTo of Object.values(plugin.connectedTo)) {
                            if (connectedTo.fields?.includes(modelField.name)) {
                                pluginName = plugin.name;
                                break;
                            }
                        }
                    }
                }
                if (!pluginName) {
                    throw new AppStructureBuilderError(`Plugin for field ${modelField.name} not found`);
                }
                return {
                    ...defaultField,
                    type,
                    plugin: pluginName,
                    pluginArguments: pluginParams,
                };
            }
            default:
                return {
                    ...defaultField,
                    type,
                };
        }
        throw new AppStructureBuilderError(`Unhandled field type: ${type}`);
    }
    getStructureFieldType(type) {
        switch (type) {
            case 'string':
                return 'text';
            case 'boolean':
                return 'checkbox';
            case 'int':
            case 'float':
                return 'number';
            case 'uuid':
                return 'text';
            case 'json':
                return 'text';
            default:
                return type;
        }
    }
    createElementColumn({ columnName, columnType, modelField, numberOfColumns, }) {
        const defaultColumn = this.createDefaultColumn({ columnName, numberOfColumns, modelField });
        if (columnType === 'plugin') {
            return {
                ...defaultColumn,
                type: columnType,
                plugin: 'default',
            };
        }
        return {
            ...defaultColumn,
            type: columnType,
        };
    }
    updateAppStructure(cb) {
        this.application = produce(this.application, draft => {
            const tempBuilder = new StructureBuilder(draft, this.schema, this.schemaExtensions);
            cb(tempBuilder);
        });
        return this;
    }
}
// TODO move to schema-utils
const HUMAN_FRIENDLY_FIELDS = [
    'name',
    'fullName',
    'firstName',
    'lastName',
    'email',
    'userName',
    'title',
    'heading',
    'label',
    'caption',
    'slug',
    'code',
    'street',
    'city',
    'country',
    'fileName',
];
// TODO move to schema-utils
export const getHumanFriendlyField = (entity) => {
    for (const field of HUMAN_FRIENDLY_FIELDS) {
        if (entity.fields[field]) {
            return field;
        }
    }
    return entity.primary;
};
export const getAllHumanFriendlyFields = (entity) => {
    const fields = [];
    for (const fieldName of HUMAN_FRIENDLY_FIELDS) {
        const field = entity.fields[fieldName];
        if (field && !isRelation(field)) {
            fields.push(field.name);
        }
    }
    return fields;
};
export const getHumanFriendlyRelationFields = (entity, allEntities) => {
    let fields = {};
    for (const field of Object.values(entity.fields)) {
        if ((isRelation(field) && field.type === Model.RelationType.OneHasOne) || field.type === Model.RelationType.ManyHasOne) {
            const targetEntity = allEntities[field.target];
            const humanFriendlyFields = getAllHumanFriendlyFields(targetEntity);
            if (humanFriendlyFields.length) {
                fields = {
                    ...fields,
                    [field.name]: humanFriendlyFields,
                };
            }
        }
    }
    return fields;
};
//# sourceMappingURL=StructureBuilder.js.map